import React, { RefObject } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";

import { ModalRef, TableCell } from "@shared/components";

export const useCatalogListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  catalogModalRef: RefObject<ModalRef>
): GridColDef[] => {
  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "name",
        headerName: translate("agreement_plans.fields.name"),
        minWidth: 250,
        flex: 1,
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <EditButton
              hideText
              onClick={() => catalogModalRef.current?.open(row)}
            />

            <DeleteButton
              hideText
              hidden={false}
              resource="v1/plan_admin"
              recordItemId={row.id}
              onSuccess={onRefetch}
            />
          </TableCell.Container>
        ),
      },
    ],
    [translate, onRefetch, catalogModalRef]
  );
};
